import React from 'react';
import { Divider, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import { formatShortDate } from 'utils/date';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useWhiteboard } from 'features/whiteboard/hooks/useWhiteboard';
import { selectIsLockedContentReadOnly } from 'features/layout/features/content/contentSlice';
import { ContentLockedAction } from 'features/layout/features/content/modals/ContentLockedByModeratorModal';
import { openModal } from 'features/modal/modalSlice';
import { restoreWhiteboardRequested } from 'features/whiteboard/drafts/actions';
import {
  selectIsRestoringWhiteboard,
  selectRestoreTarget,
} from 'features/whiteboard/drafts/whiteboardDraftsSlice';

const RestoreWhiteboardItem = () => {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation('room');

  const target = useAppSelector(selectRestoreTarget);
  const restoring = useAppSelector(selectIsRestoringWhiteboard);
  const isContentLockedForUser = useAppSelector(selectIsLockedContentReadOnly);

  const { canEditWhiteboard, canManagePrivateWhiteboards } = useWhiteboard();

  if (!target || restoring) {
    return null;
  }

  const allowed = canEditWhiteboard && (!target.isPrivate || canManagePrivateWhiteboards);

  const handleClick = () => {
    if (isContentLockedForUser) {
      dispatch(
        openModal('contentLockedByModerator', { contentAction: ContentLockedAction.WhiteboardOpen })
      );
      return;
    }

    dispatch(restoreWhiteboardRequested());
  };

  return (
    <>
      <Divider sx={{ mb: 1 }} />
      <MenuItem sx={{ height: 47 }} disabled={!allowed} onClick={handleClick}>
        <ListItemIcon sx={{ ml: -1 }}>
          <Icon name="history" />
        </ListItemIcon>
        <ListItemText
          primary={t('toolbar.restore_whiteboard')}
          secondary={formatShortDate(target.savedAt, i18n.language)}
          sx={{ my: 0 }}
          slotProps={{ secondary: { sx: { lineHeight: 1.25 } } }}
        />
      </MenuItem>
    </>
  );
};

export default RestoreWhiteboardItem;
